<script setup lang="ts">
const model = defineModel<boolean>({ required: true });
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="model"
    class="flex items-center gap-2"
    @click="model = !model"
  >
    <span
      class="relative h-5 w-10 shrink-0 rounded-full transition-colors duration-150"
      :class="model ? 'bg-tango' : 'bg-bnavy-20'"
    >
      <span
        class="absolute top-0.5 h-4 w-4 rounded-full bg-white transition-all duration-150"
        :class="model ? 'left-[22px]' : 'left-0.5'"
      />
    </span>
    <span class="truncate text-left text-sm font-medium text-bnavy-dark">
      <slot />
    </span>
  </button>
</template>
